import { useTypewriter } from '../../hooks/useTypewriter';
import { useCursor } from '../../hooks/useCursor';

interface TypewriterTextProps {
  text: string;
  delay?: number;
  onComplete?: () => void;
  className?: string;
}

export default function TypewriterText({ 
  text, 
  delay = 50, 
  onComplete,
  className = ''
}: TypewriterTextProps) {
  const { displayText, isTyping } = useTypewriter(text, delay, onComplete);
  const { cursorVisible } = useCursor();
  
  return (
    <span className={`font-tech tracking-tight ${className}`}>
      {displayText}
      {isTyping && cursorVisible && (
        <span 
          className="ml-1 inline-block w-[3px] h-[1em] bg-cyan-400 animate-cursor-blink"
          aria-hidden="true"
        />
      )}
    </span>
  );
}
